import { UniversalCarType } from './universal.car.type';
import { TimingObject } from '../common/timing.object';

export class CarTypeResult {
    CarType: UniversalCarType;
    History: UniversalCarType[];
    Timing: TimingObject;
}
